<template>
  <div class="checkoutProductExtras">
    <div class="checkoutProductExtras__imageWrapper">
      <img :src="backgroundImage" alt="prezenty" />
    </div>
    <div class="checkoutProductExtras__text">
      <div class="checkoutProductExtras__list">
        <cms-wysiwyg
          :html="content"
          additional-classes="wysiwyg--orangeBullets wysiwyg--darkText"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CmsWysiwyg from '../Cms/CmsWysiwyg';
export default {
  name: 'CheckoutProductExtras',
  components: { CmsWysiwyg },
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      backgroundImage: '/images/extraBg.png',
    };
  },
};
</script>

<style lang="scss">
.checkoutProductExtras {
  display: flex;
  width: 100%;
  min-height: 17rem;
  height: auto;
  margin-bottom: 1rem;
  margin-top: 1.8rem;
  border: 1px solid $cAddLight;
  border-radius: 4px;
  position: relative;

  @include rwd('laptop') {
    min-height: 17rem;
    height: auto;
  }

  @include rwd('tablet') {
    flex-direction: column;
  }

  @include rwd('small-tablet') {
    align-items: flex-start;
  }

  &__imageWrapper {
    flex: 0 0 50%;

    @include rwd('tablet') {
      margin-right: auto;
    }

    & img {
      width: 100%;
      position: relative;
    }
  }

  &__title {
    font-size: 1.6rem;
    line-height: 2.2rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  &__text {
    color: $cBlack;
    font-size: 1.6rem;
    line-height: 2.2rem;
    flex: 1;
    margin-left: auto;
    padding: 2rem;

    @include rwd('tablet') {
      font-size: 1.4rem;
      line-height: 1.8rem;
      margin-left: 0;
      padding: 2rem;
      max-width: 75%;
    }

    @include rwd('small-tablet') {
      max-width: 100%;
    }
  }
}
</style>
